import Immutable from 'immutable';

export function groupByLastFlag(
  list,
  flagKey = 'group_with_last',
  immutable = true
) {
  const groups = [];
  let group = [];

  const getVal = (obj, key) => (immutable ? obj.get(key) : obj[key]);

  list.forEach((item, i) => {
    group.push(item);
    const next = getVal(list, i + 1);
    if (!next || !getVal(next, flagKey)) {
      groups.push(group);
      group = [];
    }
  });
  return immutable ? Immutable.fromJS(groups) : groups;
}
